<template>
  <div class="InvoiceManagement_page">
    <div class="title_box flex_center">
      <img src="./image/order_icon3.png" class="order_icon" />
      <div class="flex_column">
        <div class="order_title">发票管理</div>
        <div class="order_subtitle"></div>
      </div>
    </div>
    <div class="filter_content font">
      <span class="order_subtitle mb12">发票时间：</span>
      <el-date-picker
        v-model="filterData.timeDate"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        class="mr12 mb12"
        size="small"
      >
      </el-date-picker>
      <span class="order_subtitle mb12">状态：</span>
      <el-select
        v-model="filterData.selectValue"
        placeholder="请选择"
        class="mr12 mb12 width150"
        size="small"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        style="background-color: #00a0e9; color: #ffffff; border-color: #00a0e9"
        size="small"
        class="mb12"
      >
        查询</el-button
      >
      <el-button
        style=""
        size="small"
        class="mb12"
      >
        申请发票</el-button
      >
    </div>
    <div class="content_box">
      <div class="table_content">
        <el-table :data="tableData" style="width: 100%; max-width: 1200px">
          <el-table-column prop="date" label="申请单号"> </el-table-column>
          <el-table-column prop="name" label="开户银行"> </el-table-column>
          <el-table-column prop="address" label="银行账号"> </el-table-column>
          <el-table-column prop="address1" label="开票类型"> </el-table-column>
          <el-table-column prop="address2" label="状态"> </el-table-column>
          <el-table-column prop="address3" label="发票编号"> </el-table-column>
          <el-table-column prop="address4" label="发票日期"> </el-table-column>
          <el-table-column prop="address5" label="发票金额"> </el-table-column>
          <el-table-column prop="address6" label="操作"> </el-table-column>
        </el-table>
        <div class="flex_end statics">
          <el-pagination
            :current-page.sync="currentPage1"
            :page-size="100"
            layout="total, prev, pager, next"
            :total="10"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filterData: {
        timeDate: [],
        keywords: "",
        selectValue: "",
        tab: "ALL",
      },
      tableData: [],
      currentPage1: 5,
      options: [
        {
          value: "选项1",
          label: "全部",
        },
        {
          value: "选项2",
          label: "未审核",
        },
        {
          value: "选项3",
          label: "通过",
        },
        {
          value: "选项4",
          label: "不通过",
        },
      ],
    };
  },
  created() {},

  methods: {},
};
</script>

<style lang="less">
.InvoiceManagement_page {
  width: 100%;
  min-height: 100%;
  border: 1px solid #e1e1e1;
  padding: 20px;
  box-sizing: border-box;
  .title_box {
    margin-bottom: 12px;
  }
  .width200 {
    width: 200px;
  }
  .width150 {
    width: 150px;
  }
  .content_box {
    width: 100%;
    box-sizing: border-box;
    .table_content {
      width: 100%;
      box-sizing: border-box;
    }
    .statics {
      font-size: 14px;
      font-weight: bold;
      margin-top: 12px;
    }
  }
}
.el-tabs__item {
  color: #999;
}
.el-tabs__item:hover {
  color: #00a0e9;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border: 1px solid #2f4050;
  border-bottom: 0;
}
.el-tabs__item.is-active {
  color: #000000;
}
</style>